module.exports = __webpack_public_path__ + "img/db.png.76e5cd54.svg";